import {FC, useCallback, useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {KTSVG} from '../../../../_metronic/helpers'
import { generatePDFV2, linkPDF } from '../../../utils/savePDF';
import { PDFJS_WORKER_URL } from '../../../utils/pdfWorkerUrl';
import useSize from '../../../hooks/useSize';
import { useToast } from '../../../pages/components/Toats';
import { useToastModal } from '../../../pages/components/ToastModal';
import ReactDOMServer from 'react-dom/server';
import { DateAno, DateCompleteBarra, DateCompleteMount, extrairMesDia } from '../../../utils/date';
import { postConvertPdfV3 } from '../../../services/ConvertPDFService';
import { getfileUrl } from '../../../services/uploadService';
import JSZip from 'jszip';
import { getInvoicePDFFile } from '../../../services/invoices';
import { useQuery } from 'react-query';
import { getReportsGenerationOnePublic } from '../../../services/reportsGenerationService';
import { getFileBase64Public } from '../../../services/files';
import { LoadingSpan } from '../../../pages/components/Loadings/loadingSpan';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { Worker, Viewer } from '@react-pdf-viewer/core';


const ReportGenerationPage: FC = () => {
  const { id } = useParams();
  const [loadingSubmitPDF, setLoadingSubmitPDF] = useState(false)
  const [typeGeneration, setTypeGeneration] = useState<string>("");
  const newPlugin = defaultLayoutPlugin();
  const navigate = useNavigate();

  const {width} = useSize();
  const { toggleToast } = useToast();
  const { toggleToastModal } = useToastModal();
  const [reportHTML, setReportHTML] = useState<string | null>(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [url, setUrl] = useState<any>(null)

  const getImage = async (key: string) => {
    try {
      const url = await getFileBase64Public(key)
      return url.base64

    } catch (error) {
      console.log(error)
      return ""
    }
  }

  const { data: report = null, isLoading: loading } = useQuery<any>(
    ["getMyReport", id],
    async () => {
      if(id){
        const myReport = await getReportsGenerationOnePublic(id ? id : "")

        const logo_url = myReport.plant 
        && myReport.plant.unitBranch 
        && myReport.plant.unitBranch.company 
        && myReport.plant.unitBranch.company.image_dark 
        ? await getImage (myReport.plant.unitBranch.company.image_dark) 
        : "https://i.postimg.cc/kXzT1qjT/sua-logo-aqui.png";

        const myObject = {
          data: myReport.data ? new Date(myReport.data) : new Date(),
          generation: myReport.generation ? myReport.generation : 0,
          performance: myReport.performance ? myReport.performance : 0,
          consumption: myReport.consumption ? myReport.consumption : 0,
          saved: myReport.saved ? myReport.saved : 0,
          financial_feedback_month: myReport.financial_feedback_month ? myReport.financial_feedback_month : 0,
          financial_feedback_year: myReport.financial_feedback_year ? myReport.financial_feedback_year : 0,
          invoiced: myReport.invoiced ? myReport.invoiced : 0,
          total_economy: myReport.total_economy? myReport.total_economy: 0,

          consumerRegister: myReport.consumerRegister? myReport.consumerRegister: 0,
          consumerInstant: myReport.consumerInstant? myReport.consumerInstant: 0,
          unitConsumerTotal: myReport.unitConsumerTotal? myReport.unitConsumerTotal: 0,
          energyInjected: myReport.energyInjected? myReport.energyInjected: 0,
          //logo: logo_url,
          logo: `data:image/jpeg;base64,${logo_url}`,

          color_company: myReport.plant && myReport.plant.unitBranch 
          && myReport.plant.unitBranch.company 
          && myReport.plant.unitBranch.company.color_primary 
          ? myReport.plant.unitBranch.company.color_primary : null,

          color_secondary: myReport.plant && myReport.plant.unitBranch 
          && myReport.plant.unitBranch.company 
          && myReport.plant.unitBranch.company.color_primary_variet 
          ? myReport.plant.unitBranch.company.color_primary_variet : null,

          prog_mensal: myReport.prog_mensal? myReport.prog_mensal: "0",
          prog_anual: myReport.prog_anual? myReport.prog_anual: "0",

          performance_anual: myReport.performance_anual? myReport.performance_anual: "0",
          generation_anual: myReport.generation_anual? myReport.generation_anual: "0",
          prog_12_meses: myReport.prog_12_meses? myReport.prog_12_meses: "0",

          //initPeriod: myReport.initPeriod ? DateCompleteBarra(myReport.initPeriod) : DateCompleteBarra(new Date()),
          //endPeriod: myReport.endPeriod ? DateCompleteBarra(myReport.endPeriod) : DateCompleteBarra(new Date()), 
          initPeriod: myReport.initPeriod ? myReport.initPeriod : new Date().toString(),
          endPeriod: myReport.endPeriod ? myReport.endPeriod : new Date().toString(),
          corporateName: myReport.plant && myReport.plant.unitBranch && myReport.plant.unitBranch.company && myReport.plant.unitBranch.company.corporateName ? myReport.plant.unitBranch.company.corporateName : "https://i.postimg.cc/kXzT1qjT/sua-logo-aqui.png",
          cnpj: myReport.plant && myReport.plant.unitBranch && myReport.plant.unitBranch.company && myReport.plant.unitBranch.company.cnpj ? myReport.plant.unitBranch.company.cnpj : "00.00.00.000/00",
          companyName: myReport.plant && myReport.plant.unitBranch && myReport.plant.unitBranch.companyName ? myReport.plant.unitBranch.companyName : "Solar Vision Filial",
          emailCompany: myReport.plant && myReport.plant.unitBranch && myReport.plant.unitBranch.emailCompany ? myReport.plant.unitBranch.emailCompany : "solarvisionfilial@lekko.com",
          namePlant: myReport.plant && myReport.plant.name ? myReport.plant.name : "Solar Vision Usina",
          capacity: myReport.plant && myReport.plant.capacity ? myReport.plant.capacity : "0",
          adressPlant: myReport.plant && myReport.plant.address ? myReport.plant.address : "Não identificado. ",
          mark: myReport.plant && myReport.plant.credential && myReport.plant.credential.mark && myReport.plant.credential.mark.name ? myReport.plant.credential.mark.name : "Não identificado. ",
          chart_daily: myReport.chart_daily ? myReport.chart_daily : {},
          chart_mouth: myReport.chart_mouth ? myReport.chart_mouth : {},
          chart_year: myReport.chart_year ? myReport.chart_year : {},
          chart_prognosis: myReport.chart_prognosis ? myReport.chart_prognosis : {},
          chart_year_generation:  myReport.chart_year_generation ? myReport.chart_year_generation : {},
          plano: myReport.plant && myReport.plant.plano ? myReport.plant.plano : "",
          chart_comsuption: myReport.chart_comsuption ? myReport.chart_comsuption : {},
          invoices: [],

          graphic_days: {},
          graphic_months: {},

          //chart_mouth: myReport.chart_mouth ? myReport.chart_mouth : {},

          idTemplate: myReport.templates && myReport.templates.length > 0 ? myReport.templates[0].id : null,
          idsTemplates: myReport.templates && myReport.templates.length > 0 ? myReport.templates.map((template: any) => {return template.id}) : [],
          templates: myReport.templates && myReport.templates.length > 0 ? myReport.templates: null,
          reportsAnt: []
        }

        return myObject
      }
    },
    {
      onError: (error) => {
        toggleToast("Erro ao buscar relatório. ", "error")
        console.log(error);
      },
    }
  )

  const graphicYear = (chart1: any, chart2: any) => {
    if (!chart1 || !chart1.meses || !chart1.valores || chart1.meses.length === 0 || chart1.valores.length === 0) {
        chart1 = { meses: [], valores: [] };
    }
  
    if (!chart2 || !chart2.meses || !chart2.valores || chart2.meses.length === 0 || chart2.valores.length === 0) {
        chart2 = { meses: [], valores: [] };
    }
  
    let valores_total = 100;
  
    const todosMeses = [...new Set([...chart1.meses, ...chart2.meses])];
  
    todosMeses.forEach(mes => {
        const valorA = chart1.meses.includes(mes) ? chart1.valores[chart1.meses.indexOf(mes)] : 0;
        const valorB = chart2.meses.includes(mes) ? chart2.valores[chart2.meses.indexOf(mes)] : 0;
        const maiorValor = Math.max(valorA, valorB);
        if (maiorValor > valores_total) {
            valores_total = maiorValor;
        }
    });
  
    return (
        <table 
            className="
              charts-css bar show-heading 
              show-labels show-primary-axis show-4-secondary-axes 
              show-data-axes data-spacing-5 hide-data"
        >
            <caption>
              <span>
                  Geração
                  <span 
                    style={{
                    background: `${report.color_company ? report.color_company: '#ffc700'}`,
                    color: `${report.color_company ? report.color_company: '#ffc700'}`,
                    marginRight: '0.5rem',
                    marginLeft: '0.5rem'
                  }}
                    
                  >
                    {" g "}
                  </span>Consumo
                  <span 
                    style={{
                      background: `${report.color_secondary ? report.color_secondary : '#00aaff'}`,
                      color: `${report.color_secondary ? report.color_secondary : '#00aaff'}`,
                      marginRight: '0.5rem',
                      marginLeft: '0.5rem'
                    }}
                      
                    >
                      {" c "}
                      </span>- (Meses Anteriores)
                </span>
            </caption>
  
            <thead>
                <tr>
                    <th scope="col"> Year </th>
                    <th scope="col"> Value </th>
                </tr>
            </thead>
  
            <tbody>
                {todosMeses.length > 0 ? (
                    todosMeses.map((mes: any, index: any) => {
                        const valorA = chart1.meses.includes(mes) ? chart1.valores[chart1.meses.indexOf(mes)] : 0;
                        const valorB = chart2.meses.includes(mes) ? chart2.valores[chart2.meses.indexOf(mes)] : 0;
                        return (
                            <tr key={index}>
                                <th style={{fontSize: '0.6rem'}}>
                                    <span style={{paddingTop: '0.5rem', color: '#181c32 !important'}}>{mes}</span>
                                </th>  
                                <td 
                                    style={{ 
                                        '--size': `calc(${valorA} / ${valores_total})`,
                                        '--color': report.color_company
                                        ? report.color_company
                                        : '#ffc700',
                                        //'--color': '#ffc700',
                                        color: '#fffefe !important',
                                        fontSize: '0.6rem'
                                    } as any}
                                >
                                    {valorA}
                                </td>
                                <td 
                                    style={{ 
                                        '--size': `calc(${valorB} / ${valores_total})`,
                                        '--color': report.color_secondary
                                        ? report.color_secondary : '#00aaff',
                                        //'--color': '#00aaff',
                                        color: '#fffefe !important',
                                        fontSize: '0.6rem'
                                    } as any}
                                >
                                    {valorB}
                                </td>
                            </tr>
                        )
                    })
                ) : (
                    <tr>
                        <td colSpan={3} style={{ textAlign: 'center' }}>Nenhum dado disponível</td>
                    </tr>
                )}
            </tbody>
        </table>
    );
  };

  const graphicYearGeneration = (chart1: any, chart2: any) => {
    if (!chart1 || !chart1.meses || !chart1.valores || chart1.meses.length === 0 || chart1.valores.length === 0) {
        chart1 = { meses: [], valores: [] };
    }
  
    if (!chart2 || !chart2.meses || !chart2.valores || chart2.meses.length === 0 || chart2.valores.length === 0) {
        chart2 = { meses: [], valores: [] };
    }
  
    let valores_total = 100;
  
    const todosMeses = [...new Set([...chart1.meses, ...chart2.meses])]
      .sort((a: string, b: string) => new Date(a).getTime() - new Date(b).getTime());
  
    todosMeses.forEach(mes => {
        const valorA = chart1.meses.includes(mes) ? chart1.valores[chart1.meses.indexOf(mes)] : 0;
        const valorB = chart2.meses.includes(mes) ? chart2.valores[chart2.meses.indexOf(mes)] : 0;
        const maiorValor = Math.max(valorA, valorB);
        if (maiorValor > valores_total) {
            valores_total = maiorValor;
        }
    });
  
    return (
        <table 
            className="
                charts-css column show-heading 
                show-labels show-primary-axis show-4-secondary-axes 
                show-data-axes data-spacing-5 hide-data"
        >
            <caption><span>Geração / Prognóstico - Ultimos 12 meses</span></caption>
  
            <thead>
                <tr>
                    <th scope="col">Mês</th>
                    <th scope="col">Valor A</th>
                    <th scope="col">Valor B</th>
                </tr>
            </thead>
  
            <tbody>
                {todosMeses.length > 0 ? (
                    todosMeses.map((mes, index) => {
                        const valorA = chart1.meses.includes(mes) ? chart1.valores[chart1.meses.indexOf(mes)] : 0;
                        const valorB = chart2.meses.includes(mes) ? chart2.valores[chart2.meses.indexOf(mes)] : 0;
                        const proporcaoA = (typeof valorA === 'number' && typeof valores_total === 'number') ? valorA / valores_total : 0;
                        const proporcaoB = (typeof valorB === 'number' && typeof valores_total === 'number') ? valorB / valores_total : 0;
                        
                        return (
                            <tr key={index}>
                                <th style={{fontSize: '0.6rem'}}>
                                    <span style={{paddingTop: '0.5rem', color: '#181c32 !important'}}>{mes}</span>
                                </th>  
                                <td 
                                    style={{ 
                                        '--size': `${proporcaoA}`,
                                        '--color': report.color_company
                                        ? report.color_company
                                        : '#ffc700',
                                        //'--color': '#ffc700',
                                        color: '#fffefe !important',
                                        fontSize: '0.6rem'
                                    } as any}
                                >
                                    {valorA}
                                </td>
                                <td 
                                    style={{ 
                                        '--size': `${proporcaoB}`,
                                        '--color': report.color_secondary
                                        ? report.color_secondary : '#00aaff',
                                        //'--color': '#00aaff',
                                        color: '#fffefe !important',
                                        fontSize: '0.6rem'
                                    } as any}
                                >
                                    {valorB}
                                </td>

                                
                            </tr>
                        )
                    })
                ) : (
                    <tr>
                        <td colSpan={3} style={{ textAlign: 'center' }}>Nenhum dado disponível</td>
                    </tr>
                )}
            </tbody>
        </table>
    );
  };

  const graphicYearComsuption = (chart2: any) => {
    if (!chart2 || !chart2.meses || !chart2.valores || chart2.meses.length === 0 || chart2.valores.length === 0) {
        chart2 = { meses: [], valores: [] };
    }
  
    let valores_total = 100;
  
    const todosMeses = [...new Set(chart2.meses)];
  
    todosMeses.forEach(mes => {
        const valorB = chart2.meses.includes(mes) ? chart2.valores[chart2.meses.indexOf(mes)] : 0;
        if (valorB > valores_total) {
            valores_total = valorB;
        }
    });
  
    return (
      <table 
          className="
            charts-css column show-heading 
            show-labels show-primary-axis show-4-secondary-axes 
            show-data-axes data-spacing-5 hide-data"
      >
          <caption><span>Consumo - meses anteriores - {DateAno(report.data)}</span></caption>

          <thead>
              <tr>
                  <th scope="col"> Month </th>
                  <th scope="col"> Value </th>
              </tr>
          </thead>

          <tbody>
              {todosMeses.length > 0 ? (
                  todosMeses.map((mes: any, index: any) => {
                      const valorB = chart2.meses.includes(mes) ? chart2.valores[chart2.meses.indexOf(mes)] : 0;
                      return (
                          <tr key={index}>
                              <th style={{fontSize: '0.6rem'}}>
                                  <span style={{paddingTop: '0.5rem', color: '#181c32 !important'}}>{mes}</span>
                              </th>  
                              <td 
                                  style={{ 
                                      '--size': `calc(${valorB} / ${valores_total})`,
                                      '--color': report.color_company
                                      ? report.color_company
                                      : '#ffc700',
                                      //'--color': '#ffc700',
                                      //'--color': '#00aaff',
                                      color: '#fffefe !important',
                                      fontSize: '0.6rem'
                                  } as any}
                              >
                                  {valorB}
                              </td>
                          </tr>
                      )
                  })
              ) : (
                  <tr>
                      <td colSpan={2} style={{ textAlign: 'center' }}>Nenhum dado disponível</td>
                  </tr>
              )}
          </tbody>
      </table>
    );
  };

  const graphicMouthV2 = (charts_mouth: any) => {
    const chart = charts_mouth;

    let valores_total = 0;

    if (chart && chart.valores && chart.valores.length > 0) {
      valores_total = Math.max(...chart.valores);
    }

    const maxBarHeight = 100;

    return (
      <div
        style={{
          maxWidth: '900px',
          overflowX: 'auto', 
          overflowY: 'hidden',
          margin: '0 auto', 
        }}
      >
        <table
          className="
            charts-css column show-heading show-labels 
            show-primary-axis show-4-secondary-axes show-data-axes 
            data-spacing-5 hide-data"
          style={{
            maxHeight: `${maxBarHeight + 50}px`,
            width: 'auto',
            tableLayout: 'auto',
          }}
        >
          <thead>
            <tr>
              <th scope="col">Year</th>
              <th scope="col">Value</th>
            </tr>
          </thead>

          <tbody style={{ height: '150px' }}>
            {chart &&
              chart.dias &&
              chart.dias.map((dia: any, index: any) => {
                if (chart.valores && chart.valores[index] !== 0) {
                  const normalizedHeight =
                    valores_total > 0
                      ? (chart.valores[index] / valores_total) * maxBarHeight
                      : 0;

                  const barHeight = Math.max(normalizedHeight, 10);

                  return (
                    <tr key={index}>
                      <th style={{ fontSize: '0.55rem' }}>
                        <span style={{ paddingTop: '0.5rem', color: '#181c32' }}>
                          {extrairMesDia(dia)}
                        </span>
                      </th>
                      <td
                        style={{
                          height: `${barHeight}px`,
                          backgroundColor: report.color_company
                            ? report.color_company
                            : '#ffc700',
                          color: 'black',
                          fontSize: '0.7rem',
                          textAlign: 'center',
                          verticalAlign: 'bottom',
                          display: 'flex',
                          alignItems: 'flex-start',
                          justifyContent: 'center',
                          position: 'relative',
                        }}
                      >
                        {chart && chart.valores ? chart.valores[index] : 0}
                      </td>
                    </tr>
                  );
                }
              })}
          </tbody>
        </table>
      </div>
    );
  };

  const processDocx = async (fileOrUrl: any, placeholders: any) => {
    try {
        let file;

        if (typeof fileOrUrl === "string") {
            const response: any = await getInvoicePDFFile(fileOrUrl);
            if (response) {
                const blob = response.data;
                file = new File([blob], "original-document.docx", { type: blob.type });
            }
        }

        if (file) {
            const arrayBuffer = await file.arrayBuffer();
            const zip: any = await JSZip.loadAsync(arrayBuffer);

            let documentXml = await zip.file("word/document.xml").async("string");

            // Limpeza de placeholders antigos e erros
            let cleanedXml = documentXml.replace(/<w:t[^>]*>({{)?<\/w:t>\s*<w:r[^>]*><w:t[^>]*>(.*?)<\/w:t>\s*<w:r[^>]*><w:t[^>]*>(}})?<\/w:t>/g, "{{$2}}");
            cleanedXml = cleanedXml.replace(/<w:proofErr[^>]*>/g, "");

            let imageCounter = 1;

            for (const [placeholder, value] of Object.entries(placeholders)) {
                if (typeof value === "string" && value.startsWith("data:image/")) {
                    // Se for uma imagem em base64, precisamos adicioná-la ao zip
                    const base64Data = value.split(",")[1]; // Remove o prefixo "data:image/png;base64,"
                    const imageBuffer = Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));

                    const imageName = `image${imageCounter}.png`;
                    zip.file(`word/media/${imageName}`, imageBuffer);

                    // Substituir o placeholder no XML para referenciar a imagem
                    cleanedXml = cleanedXml.replace(
                        new RegExp(`\\{\\{\\s*${placeholder}\\s*\\}\\}`, "g"),
                        `<w:drawing>
                            <wp:inline>
                                <a:graphic>
                                    <a:graphicData>
                                        <pic:pic>
                                            <pic:blipFill>
                                                <a:blip r:embed="rId${imageCounter}"/>
                                            </pic:blipFill>
                                        </pic:pic>
                                    </a:graphicData>
                                </a:graphic>
                            </wp:inline>
                        </w:drawing>`
                    );
                    imageCounter++;
                } else {
                    // Substituir texto normal
                    const regex = new RegExp(`\\{\\{\\s*${placeholder}\\s*\\}\\}`, "g");
                    cleanedXml = cleanedXml.replace(regex, value);
                }
            }

            zip.file("word/document.xml", cleanedXml);
            const updatedDocx = await zip.generateAsync({ type: "blob" });

            const pdfFormData = new FormData();
            pdfFormData.append("file", updatedDocx, "processed-document.docx");

            const response = await postConvertPdfV3(pdfFormData);
            const pdfBlob = new Blob([response.data], { type: "application/pdf" });

            const uploadFormData = new FormData();
            uploadFormData.append("file", pdfBlob, "final-document.pdf");

            const uploadResponse = await getfileUrl(uploadFormData);

            if (uploadResponse && uploadResponse.url) {
                let pdfUrl = uploadResponse.url;

                // if (width && width < 1000) {
                //     const url = new URL(pdfUrl);
                //     url.searchParams.append("open_external_app", "true");
                //     pdfUrl = url.toString();
                // }
                toggleToastModal(
                  "Relatório Gerado com sucesso!",
                  `${pdfUrl}`,
                  "success"
                );

                window.open(pdfUrl, "_blank", "noopener,noreferrer");

            } else {
                console.error("Erro ao obter a URL do arquivo após o upload.");
            }
            console.log("Documento processado e convertido para PDF com sucesso!");
        }
    } catch (error) {
        console.error("Erro ao processar o documento:", error);
    }
  };
  
  const substituteValues = async (file: any) => {
    try {
      if (file) {
        let placeholderData = {
          year: () => {
            if(report.data){
              const data = new Date(report.data);
              const year = data.getFullYear();
  
              return year.toString();
            }
            return ""
          },
          month: () => {
            if(report.data){
              const mounthYear = [
                'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
                'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
              ];
      
              const data = new Date(report.data);
              const month = data.getMonth() + 1;
              const nameMonth = mounthYear[month - 1];
      
              return nameMonth
            }
            return ""
          },
          generation: report && report && report.generation ? report.generation : "",
          performance: report && report && report.performance ? report.performance : "",
          consumption: report && report && report.consumption ? report.consumption : "" ,
          saved: report && report && report.saved ? report.saved : "" ,
          initPeriod: report && report && DateCompleteBarra(report.initPeriod) ? report.initPeriod : "" ,
          endPeriod: report && report && DateCompleteBarra(report.endPeriod) ? report.endPeriod : "" , 
          corporateName: report && report && report.corporateName ? report.corporateName : "" ,
    
          performance_anual: report && report && report.performance_anual ? report.performance_anual : "" ,
          generation_anual: report && report && report.generation_anual ? report.generation_anual : "" ,
          prog_12_meses: report && report && report.prog_12_meses ? report.prog_12_meses : "" ,
          capacity: report && report && report.capacity ? report.capacity : "",
    
          economia_co2: report && report && report.economia_co2 ? report.economia_co2 : "",
          arvores_salvas: report && report && report.arvores_salvas ? report.arvores_salvas : "",
    
          //invoiced: report && report && report.invoiced ? report.invoiced : "",
  
          invoiced: report && report.invoiced && Number(report.invoiced) > 0 
              ? report.invoiced.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
              : '0,00',
  
          //total_economy: report && report && report.total_economy ? report.total_economy : "",
          
          total_economy: report && report.total_economy && Number(report.total_economy) > 0 
          ? report.total_economy.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
          : '0,00',
  
          financial_feedback_month: report && report && report.financial_feedback_month ? report.financial_feedback_month : "",
          financial_feedback_year: report && report && report.financial_feedback_year ? report.financial_feedback_year : "",
    
          consumerRegister: report && report && report.consumerRegister ? report.consumerRegister : "",
          consumerInstant: report && report && report.consumerInstant ? report.consumerInstant : "",
          unitConsumerTotal: report && report && report.unitConsumerTotal ? report.unitConsumerTotal : "",
          energyInjected: report && report && report.energyInjected ? report.energyInjected : "",
    
          cnpj: report && report && report.cnpj ? report.cnpj : "",
          companyName: report && report && report.companyName ? report.companyName : "" ,
          emailCompany: report && report && report.emailCompany ? report.emailCompany : "",
          namePlant: report && report && report.namePlant ? report.namePlant : "",
          adressPlant: report && report && report.adressPlant ? report.adressPlant : "",
          mark: report && report && report.mark ? report.mark : "" ,
    
          // chart_comsuption: report && report && report.chart_comsuption ? report.chart_comsuption : "",
          // graphic_mensal_combination: report && report && report.graphic_mensal_combination ? report.graphic_mensal_combination : "",
          // graphic_days: report && report.chart_mouth ? await captureGraphicAsImage(report.chart_mouth): "",
          // graphic_months: report && report && report.graphic_months ? "": "",
        }
        await processDocx(file, placeholderData);
      }
    } catch (error) {
      console.error("Erro ao processar o documento:", error);
    }
  }
  
  const replaceValues = (dados: any, html: string) => {
    let novoHtml = html;
    
    Object.keys(dados).forEach(chave => {
      if(chave === 'data'){
        const mounthYear = [
          'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
          'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
        ];

        const data = new Date(dados[chave]);
        const year = data.getFullYear();
        const month = data.getMonth() + 1;
        const nameMonth = mounthYear[month - 1];

        const marcadorYear = new RegExp(`{{year}}`, 'g');
        const marcadorMonth = new RegExp(`{{month}}`, 'g');

        novoHtml = novoHtml.replace(marcadorYear, year.toString());
        novoHtml = novoHtml.replace(marcadorMonth, nameMonth);
      }else{
        if(chave === 'reportsAnt'){

          const reportsHtml = dados[chave].map((report: any) => {
            const tds = Object.keys(report).map(key => {
              return `
                <td>
                  <div class='d-flex align-items-center'>
                    <div class='d-flex justify-content-start flex-column'>
                      <a href='#' style="color: #181c32" class='fw-bold text-hover-primary mb-1 fs-9'>
                        ${report[key]}
                      </a>
                    </div>
                  </div>
                </td>
              `  
              //return `<td>${report[key]}</td>`;
            }).join('');
            return `<tr>${tds}</tr>`;
        }).join('');
        
        // Adiciona as trs ao HTML

        novoHtml = novoHtml.replace(
          `<tbody id="table_reports"><tr><td colspan="4"><span>Valores de relatorios anteriores</span></td></tr></tbody>`, 
          `<tbody id="table_reports">${reportsHtml}</tbody>`
        );


        }else{
          if(chave === 'chart_mouth'){
            const charts_mouth = dados[chave];
            
            novoHtml = novoHtml.replace(
              `<div id="chart_daily" style="height: 15.5rem; border-color: #e1e3ea !important" class="border border-dashed rounded">Gráficos dos dias</div>`, 
              `<div id="chart_daily" style="height: 170px; border-color: #e1e3ea !important" class="border border-dashed rounded">${
                ReactDOMServer.renderToString(graphicMouthV2(charts_mouth))
                //teste()
                  // ReactDOMServer.renderToString(<BarGraph className='card-xl-stretch mb-xl-8' charts={charts_mouth}/>)
                // <BarGraph className='card-xl-stretch mb-xl-8' charts={charts_mouth}/>
              }
              </div>`
            );

            novoHtml = novoHtml.replace(
              `<div class="border border-dashed rounded" style="border-bottom-color:#e1e3ea;border-left-color:!important;border-right-color:!important;border-top-color:#e1e3ea;height:15.5rem;" id="chart_daily">Gráficos dos dias</div>`, 
              `<div id="chart_daily" style="height: 170px; border-color: #e1e3ea !important" class="border border-dashed rounded">${
                ReactDOMServer.renderToString(graphicMouthV2(charts_mouth))
                //teste()
                  // ReactDOMServer.renderToString(<BarGraph className='card-xl-stretch mb-xl-8' charts={charts_mouth}/>)
                // <BarGraph className='card-xl-stretch mb-xl-8' charts={charts_mouth}/>
              }
              </div>`
            );

          }else{
            if(chave === 'chart_year'){
            
            const charts_year = dados[chave];
            const charts_comsuption = dados["chart_comsuption"]

            novoHtml = novoHtml.replace(
              `<div id="chart_mouth" style="flex: 7; border-color: #e1e3ea !important" class="border border-dashed rounded">Gráficos mensais</div>`, 
              `<div id="chart_mouth" style="flex: 7; border-color: #e1e3ea !important" class="border border-dashed rounded">${
                ReactDOMServer.renderToString(graphicYear(charts_year, charts_comsuption))
              }
              </div>`
            );

            novoHtml = novoHtml.replace(
              `<div class="border border-dashed rounded" style="border-bottom-color:#e1e3ea;border-left-color:!important;border-right-color:!important;border-top-color:#e1e3ea;flex:7;" id="chart_mouth">Gráficos mensais</div>`, 
              `<div id="chart_mouth" style="flex: 7; border-color: #e1e3ea !important" class="border border-dashed rounded">${
                ReactDOMServer.renderToString(graphicYear(charts_year, charts_comsuption))
              }
              </div>`
            );

            }else{
              if(chave === 'graphic_days'){
                const charts_mouth = dados['chart_mouth'];
                
                const marcador = new RegExp(`{{${chave}}}`, 'g');
                novoHtml = novoHtml.replace(marcador, `<div id="chart_daily" style="height: 170px; border-color: #e1e3ea !important" class="border border-dashed rounded">${
                    ReactDOMServer.renderToString(graphicMouthV2(charts_mouth))
                    //teste()
                      // ReactDOMServer.renderToString(<BarGraph className='card-xl-stretch mb-xl-8' charts={charts_mouth}/>)
                    // <BarGraph className='card-xl-stretch mb-xl-8' charts={charts_mouth}/>
                  }
                  </div>`);

              }else{
                if(chave === 'graphic_months'){
                  const charts_year = dados['chart_year'];
                  const charts_comsuption = dados["chart_comsuption"]

                  const marcador = new RegExp(`{{${chave}}}`, 'g');
                  novoHtml = novoHtml.replace(
                    marcador,
                    `<div id="chart_mouth" style="flex: 7; border-color: #e1e3ea !important" class="border border-dashed rounded">${
                      ReactDOMServer.renderToString(graphicYear(charts_year, charts_comsuption))
                    }
                    </div>`
                  );

                }else{
                  if(chave === 'initPeriod'){
                    const myDate = DateCompleteBarra(dados[chave]);
                    
                    const marcador = new RegExp(`{{${chave}}}`, 'g');
                    novoHtml = novoHtml.replace(marcador, myDate);

                  }else{
                    if(chave === 'endPeriod'){
                      const myDate = DateCompleteBarra(dados[chave]);
                      
                      const marcador = new RegExp(`{{${chave}}}`, 'g');
                      novoHtml = novoHtml.replace(marcador, myDate);
  
                    }else{
                      // if(chave === 'invoices'){
                      //   const invoicesHtml = dados[chave].map((invoice: any) => {
                      //     const tds = Object.keys(invoice).map(key => {
                      //       if(key === 'dateInit' || key === 'dateAnd'){
                      //           return `
                      //             <td>
                      //               <div class='d-flex align-items-center'>
                      //                 <div class='d-flex justify-content-start flex-column'>
                      //                   <a href='#' style="color: #181c32" class='fw-bold text-hover-primary mb-1 fs-9'>
                      //                     ${DateCompleteBarra(invoice[key])}
                      //                   </a>
                      //                 </div>
                      //               </div>
                      //             </td>
                      //           `  
                      //       }

                      //       if(key === 'energia_registrada' 
                      //         || key === 'energia_compensada' 
                      //         || key === 'energia_faturada' 
                      //         || key === 'creditos_ant'
                      //         || key === 'creditos'
                      //       ){
                      //         return `
                      //         <td>
                      //           <div class='d-flex align-items-center'>
                      //             <div class='d-flex justify-content-start flex-column'>
                      //               <a href='#' style="color: #181c32" class='fw-bold text-hover-primary mb-1 fs-9'>
                      //                 ${invoice[key]} KWh
                      //               </a>
                      //             </div>
                      //           </div>
                      //         </td>
                      //       `  
                      //       }

                      //       if(key === 'valor_faturado' || key === 'economizado' ){
                      //         return `
                      //         <td>
                      //           <div class='d-flex align-items-center'>
                      //             <div class='d-flex justify-content-start flex-column'>
                      //               <a href='#' style="color: #181c32" class='fw-bold text-hover-primary mb-1 fs-9'>
                      //                 R$ ${invoice[key]}
                      //               </a>
                      //             </div>
                      //           </div>
                      //         </td>
                      //       `  
                      //       }
                      //       return `
                      //         <td>
                      //           <div class='d-flex align-items-center'>
                      //             <div class='d-flex justify-content-start flex-column'>
                      //               <a href='#' style="color: #181c32" class='fw-bold text-hover-primary mb-1 fs-9'>
                      //                 ${invoice[key]}
                      //               </a>
                      //             </div>
                      //           </div>
                      //         </td>
                      //       `  
                      //       //return `<td>${report[key]}</td>`;
                      //     }).join('');
                      //     return `<tr>${tds}</tr>`;
                      // }).join('');
                      
                      // // Adiciona as trs ao HTML
              
                      // novoHtml = novoHtml.replace(
                      //   `{{informationsConcessionaries}}`, 
                      //   `<div class='table-responsive'>
                      //       <table class='table align-middle gs-0'>
                      //           <thead>
                      //               <tr class='fw-bold text-muted' style="background: #f9f9f9;">
                      //                   <th class='min-w-30px rounded-start'><span class="fs-9">Contrato</span></th>
                      //                   <th class='min-w-40px rounded-start'><span class="fs-9">Inicio</span></th>
                      //                   <th class='min-w-40px rounded-start'><span class="fs-9">Fim</span></th>
                      //                   <th class='min-w-40px'><span class="fs-9">Consumo Registrado</span></th>
                      //                   <th class='min-w-40px'><span class="fs-9">Energia Compensada</span></th>
                      //                   <th class='min-w-40px'><span class="fs-9">Energia Faturada</span></th>
                      //                   <th class='min-w-40px'><span class="fs-9">Créditos Acumulados (Anterior)</span></th>
                      //                   <th class='min-w-40px'><span class="fs-9">Créditos Acumulados (Atual)</span></th>
                      //                   <th class='min-w-40px'><span class="fs-9">Faturado</span></th>
                      //                   <th class='min-w-40px'><span class="fs-9">Economizado</span></th>
                      //               </tr>
                      //           </thead>
                                
                      //           <tbody id="table_reports">${invoicesHtml}</tbody>
                      //       </table>
                      //   </div>
                      //   `
                      // );
                      // }

                      if (chave === 'invoices') {
                        const invoicesHtml = dados[chave].map((invoice: any) => {
                          const tds = Object.keys(invoice).map(key => {
                            if (key === 'dateInit' || key === 'dateAnd') {
                              return `
                                <td>
                                  <div class='d-flex align-items-center'>
                                    <div class='d-flex justify-content-start flex-column'>
                                      <a href='#' style="color: #181c32" class='fw-bold text-hover-primary mb-1 fs-9'>
                                        ${DateCompleteBarra(invoice[key])}
                                      </a>
                                    </div>
                                  </div>
                                </td>
                              `;
                            }
                      
                            if (
                              key === 'energia_registrada' ||
                              key === 'energia_compensada' ||
                              key === 'energia_faturada' ||
                              key === 'creditos_ant' ||
                              key === 'creditos'
                            ) {
                              return `
                                <td>
                                  <div class='d-flex align-items-center'>
                                    <div class='d-flex justify-content-start flex-column'>
                                      <a href='#' style="color: #181c32" class='fw-bold text-hover-primary mb-1 fs-9'>
                                        ${invoice[key]} KWh
                                      </a>
                                    </div>
                                  </div>
                                </td>
                              `;
                            }
                      
                            if (key === 'valor_faturado' || key === 'economizado') {
                              return `
                                <td>
                                  <div class='d-flex align-items-center'>
                                    <div class='d-flex justify-content-start flex-column'>
                                      <a href='#' style="color: #181c32" class='fw-bold text-hover-primary mb-1 fs-9'>
                                        R$ ${invoice[key]}
                                      </a>
                                    </div>
                                  </div>
                                </td>
                              `;
                            }
                      
                          //  if(key === ""){
                          //   return `
                          //     <td>
                          //       <div class='d-flex align-items-center'>
                          //         <div class='d-flex justify-content-start flex-column'>
                          //           <a href='#' style="color: #181c32" class='fw-bold text-hover-primary mb-1 fs-9'>
                          //             ${invoice[key]}
                          //           </a>
                          //         </div>
                          //       </div>
                          //     </td>
                          //   `;
                          //  }
                          }).join('');
                          return `<tr>${tds}</tr>`;
                        }).join('');
                      
                        // Calcular as somas dos campos taxa_iluminacao, icms, pis e cofins
                        const totais = dados['invoices'].reduce(
                          (acc: any, invoice: any) => ({
                            taxa_iluminacao: acc.taxa_iluminacao + (parseFloat(invoice.taxa_iluminacao?.replace(',', '.') || '0') || 0),
                            icms: acc.icms + (parseFloat(invoice.icms?.replace(',', '.') || '0') || 0),
                            pis: acc.pis + (parseFloat(invoice.pis?.replace(',', '.') || '0') || 0),
                            cofins: acc.cofins + (parseFloat(invoice.cofins?.replace(',', '.') || '0') || 0),
                          }),
                          { taxa_iluminacao: 0, icms: 0, pis: 0, cofins: 0 }
                        );
                      
                        // Substituir os placeholders no HTML
                        novoHtml = novoHtml.replace(
                          `{{informationsConcessionaries}}`,
                          `<div class='table-responsive'>
                              <table class='table align-middle gs-0'>
                                  <thead>
                                      <tr class='fw-bold text-muted' style="background: #f9f9f9;">
                                          <th class='min-w-30px rounded-start'><span class="fs-9">Contrato</span></th>
                                          <th class='min-w-40px rounded-start'><span class="fs-9">Inicio</span></th>
                                          <th class='min-w-40px rounded-start'><span class="fs-9">Fim</span></th>
                                          <th class='min-w-40px'><span class="fs-9">Consumo Registrado</span></th>
                                          <th class='min-w-40px'><span class="fs-9">Energia Compensada</span></th>
                                          <th class='min-w-40px'><span class="fs-9">Energia Faturada</span></th>
                                          <th class='min-w-40px'><span class="fs-9">Créditos Acumulados (Anterior)</span></th>
                                          <th class='min-w-40px'><span class="fs-9">Créditos Acumulados (Atual)</span></th>
                                          <th class='min-w-40px'><span class="fs-9">Faturado</span></th>
                                          <th class='min-w-40px'><span class="fs-9">Economizado</span></th>
                                      </tr>
                                  </thead>
                                  <tbody id="table_reports">${invoicesHtml}</tbody>
                              </table>
                          </div>`
                        );
                      
                        // Substituir os placeholders de taxa_iluminacao, icms, pis e cofins com formato brasileiro
                        novoHtml = novoHtml.replace(`{{taxa_iluminacao}}`, `R$ ${totais.taxa_iluminacao.toFixed(2).replace('.', ',')}`);
                        novoHtml = novoHtml.replace(`{{icms}}`, `R$ ${totais.icms.toFixed(2).replace('.', ',')}`);
                        novoHtml = novoHtml.replace(`{{pis}}`, `R$ ${totais.pis.toFixed(2).replace('.', ',')}`);
                        novoHtml = novoHtml.replace(`{{cofins}}`, `R$ ${totais.cofins.toFixed(2).replace('.', ',')}`);
                      }
                      
                      else{
                        if(chave === 'chart_year_generation'){
            
                          const charts_year_generation = dados[chave];
                          const charts_prognosis = dados["chart_prognosis"]
              
                          novoHtml = novoHtml.replace(
                            `{{graphic_mensal_combination}}`, 
                            `<div id="chart_mouth" style="height: 30rem; flex: 7; border-color: #e1e3ea !important" class="border border-dashed rounded">${
                              ReactDOMServer.renderToString(graphicYearGeneration(charts_year_generation, charts_prognosis))
                            }
                            </div>`
                          );

                          novoHtml = novoHtml.replace(
                            `{{graphic_mensal_combination}}`, 
                            `<div id="chart_mouth" style="height: 30rem; flex: 7; border-color: #e1e3ea !important" class="border border-dashed rounded">${
                              ReactDOMServer.renderToString(graphicYearGeneration(charts_year_generation, charts_prognosis))
                            }
                            </div>`
                          );

                        }else{
                          if(chave === 'chart_comsuption'){
                            //const charts_year = dados[chave];
                            const charts_comsuption = dados[chave]
          
                            const marcador = new RegExp(`{{${chave}}}`, 'g');
                            novoHtml = novoHtml.replace(
                              marcador,
                              `<div id="chart_mouth" style="height: 10rem; flex: 7; border-color: #e1e3ea !important" class="border border-dashed rounded">${
                                ReactDOMServer.renderToString(graphicYearComsuption(charts_comsuption))
                              }
                              </div>`
                            );
                          }else{
                            if(chave === 'generation'){
                              
                              if(dados[chave] && !isNaN(Number(dados[chave]))){
                                const generation = Number(dados[chave])
                                
                                const economia_co2 = (generation * 0.53)
                                const arvores_salvas = economia_co2 / 22

                                const marcador_economia_co2 = new RegExp(`{{economia_co2}}`, 'g');
                                novoHtml = novoHtml.replace(marcador_economia_co2, (economia_co2 / 1000).toFixed(2).toString());

                                const marcador_arvores_salvas = new RegExp(`{{arvores_salvas}}`, 'g');
                                novoHtml = novoHtml.replace(marcador_arvores_salvas, arvores_salvas.toFixed(2).toString());

                              }else{
                                const marcador_economia_co2 = new RegExp(`{{economia_co2}}`, 'g');
                                novoHtml = novoHtml.replace(marcador_economia_co2, "0");

                                const marcador_arvores_salvas = new RegExp(`{{arvores_salvas}}`, 'g');
                                novoHtml = novoHtml.replace(marcador_arvores_salvas, "0");
                              } 

                              const marcador = new RegExp(`{{${chave}}}`, 'g');
                              novoHtml = novoHtml.replace(marcador, dados[chave]);

                            }else{
                              const marcador = new RegExp(`{{${chave}}}`, 'g');
                              novoHtml = novoHtml.replace(marcador, dados[chave]);
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

    if(novoHtml.includes("report_template")){
      return novoHtml;
    }else{
      return "<div id='report_template'>" + novoHtml + "</div>"
    }
  };

  const openPDF = (url: string) => {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const previewPDF = async (templateHtml: string) => {
    try {
      setPdfLoading(true)
      const myReturnLink = await linkPDF(templateHtml)
      setUrl(myReturnLink) 
    
    } catch (error) {
      console.log(error)  
    }finally{
      setPdfLoading(false)
    }
  }

  const generatePDF = useCallback(async (typeReport: string) => {
    setTypeGeneration(typeReport)
    setLoadingSubmitPDF(true);
    try {
      const template_generation = report?.templates?.find(t => t.type_template === typeReport);
      if (!template_generation){
        toggleToast("Nenhum template vinculado ao relatório. ", "error")
      };
   
      if(template_generation.typeDoc && template_generation.typeDoc === 'html'){
        const htmlContent = report ? replaceValues(report, template_generation.textHTML) : "<div>template não encontrado</div>";
        const myPDF = await generatePDFV2(htmlContent, "report_template");
        
        if (myPDF?.url) {
          //toggleToast(`${myPDF.url}`, "success");
          
          toggleToastModal(
            "Relatório Gerado com sucesso!",
            `${myPDF.url}`,
            "success"
          );
          openPDF(myPDF.url);

  
        }else{
          toggleToast(`Erro ao gerar o PDF`, "error")
        }
      }else{
        if(template_generation.typeDoc && template_generation.typeDoc === 'docx'){
          await substituteValues(template_generation.linkDocx)
        }
      }
      
    }catch(error){
      console.log(error);
      //toggleToast(`Erro ao gerar o PDF`, "error")
    } finally {
      setLoadingSubmitPDF(false);
      setTypeGeneration("")
    }
  }, [report, width]);


  const submit = async (typeReport: string) => {
    generatePDF(typeReport)
  }

  const hasAuthToken = () => {
    try {
      const data = localStorage.getItem('kt-auth-react-v');
      if (!data) return false;
  
      const parsed = JSON.parse(data);
      return !!parsed?.api_token;
    } catch (err) {
      console.error('Erro ao ler token do localStorage:', err);
      return false;
    }
  }

  useEffect(() => {
    if(report){

      document.documentElement.style.setProperty('--bs-primary',  
        report.color_company
        ? report.color_company
        : '#ffc700');
  
      document.documentElement.style.setProperty('--bs-text-primary', 
        report.color_company
        ? report.color_company
        : '#ffc700');
        
      document.documentElement.style.setProperty('--bs-secondary', 
        report.color_secondary
        ? report.color_secondary : '#181c32');
  
      document.documentElement.style.setProperty('--bs-primary-active', 
        report.color_secondary
        ? report.color_secondary : '#181c32');
  
  
      const template_generation = report?.templates?.find(t => t.type_template === "GERACAO");
      if (!template_generation){
        toggleToast("Nenhum template vinculado ao relatório. ", "error")
        return;
      }
   
      if(template_generation.typeDoc && template_generation.typeDoc === 'html'){
        const htmlContent = report ? replaceValues(report, template_generation.textHTML) : "<div>template não encontrado</div>";
        setReportHTML(htmlContent);

        previewPDF(htmlContent)
      }
    }
  }, [report])
  
  return (
    <>
    {hasAuthToken() === true && 
        <a
          href='#'
          className='text-gray-500 fw-bold text-hover-primary d-block mb-4 fs-6'
          onClick={() => {navigate("/dashboard");}}
        >
          <span style={{}}>
            <KTSVG
              path='/media/icons/duotune/arrows/arr063.svg'
              className='svg-icon-3 me-2'
            />
            voltar
        </span>
      </a>}

      <div className='mb-0' style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem'}}>
        {/* <Link to='/dashboard' className='btn btn-sm btn-primary'>
          Retornar para Dashboard
        </Link> */}
        <h1 className={`fw-bolder fs-${width < 760 ? "4" : "1hx"} text-gray-900 mb-4`}>Relatório {report && report.data ? `- ${DateCompleteMount(report.data)}` : ""} (GERAÇÃO)</h1>
        <button
          type='button'
          className={`btn btn-${width > 1200 ? "lg" : "sm"} btn-secondary text-light`}
          disabled={
            loadingSubmitPDF
            || loading
            || (report && report.templates && !report.templates.some((template: any) => template.type_template === 'GERACAO'))
            ? true
            : false
          }
          onClick={() => {submit('GERACAO')}}
        >
          Download
          {
            loadingSubmitPDF && typeGeneration === "GERACAO" ? 
              <LoadingSpan style={{marginLeft: '0.5rem'}}/>
            :
              <KTSVG
                path='/media/icons/duotune/arrows/arr064.svg'
                className='svg-icon-3 ms-2 me-0 text-light'
              />
              }
        </button> 
      </div>
      {width < 760 ?
        pdfLoading ?
        <LoadingSpan style={{marginLeft: '1rem'}}/>
        :
        url ? (
          <div
            className='mt-4 card p-2'
            style={{background: 'white'}}
          >
            <Worker workerUrl={PDFJS_WORKER_URL}>
              <Viewer fileUrl={url} plugins={[newPlugin]}/>
            </Worker>
          </div>
        ) : 
          <div
            className='fw-bold fs-6 text-gray-400'
            style={{
              height: '40rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
          Visualize seu relatório.
        </div>
      :
      
      loading ?
        <LoadingSpan style={{marginLeft: '1rem'}}/>
      : reportHTML && (
        <div
          className='mt-4 card p-2'
          style={{background: 'white'}}
          dangerouslySetInnerHTML={{ __html: reportHTML }}
        />
      )}
    </>
  )
}

export {ReportGenerationPage}
